module.exports = __webpack_public_path__ + "assets/img/wei1.e14d1989.png";